import React from 'react';
// import { Container, colors, Figure } from 'globalStyle';
import { colors, Div, Figure } from 'globalStyle';
import styled from 'styled-components';
import Box from '@material-ui/core/Box';
import { routes } from 'routes';
import { Ghost, colorType } from 'components/Buttons';
import { TextLight, Title, Text } from 'components/Texts';
import logo from 'assets/akademia-white.svg';
import casf from 'assets/casf-white.svg';
import ImageLazyLoad from 'page/components/LazyLoadingImage';

export const Mobile = () => (
  <>
    <FooterContainer>
      <ContainerInfo>
        <Div
          isFlex
          direction="column"
          align="center"
          margin="0 0 30px"
        >
          <Figure
            width="200px"
            height="200px"
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              overflow: 'hidden',
            }}
          >
            <img
              src={logo}
              alt="logo"
              style={{
                maxWidth: '100%',
                maxHeight: '100%',
                width: 'auto',
                height: 'auto',
                objectFit: 'contain',
              }}
            />
          </Figure>
          <TextLight
            size={13}
            color={colors.WHITE}
            mt={15}
            isCenter
            style={{ maxWidth: '32ch' }}
          >
            Akademia es un simulador educativo. No actúa como entidad de crédito,
            intermediario de valores ni plataforma de inversión real, y no desempeña
            el papel de asesor financiero.
          </TextLight>
        </Div>

        <Div>
          <Title size={18} color={colors.WHITE} mb={12}>
            Explora
          </Title>

          <Div isFlex direction="column" align="start">
            <Ghost
              href={routes.aboutUs}
              onColorType={colorType.GRAY}
              color={colors.WHITE}
              style={{ 'font-size': '13px' }}
              mb={10}
            >
              Acerca de nosotros
            </Ghost>
            <Ghost
              href={routes.frequentQuestions}
              onColorType={colorType.GRAY}
              color={colors.WHITE}
              style={{ 'font-size': '13px' }}
              mb={10}
            >
              Preguntas frecuentes
            </Ghost>

            <Ghost
              href={routes.message.team}
              onColorType={colorType.GRAY}
              color={colors.WHITE}
              style={{ 'font-size': '13px' }}
              mb={10}
            >
              Empleos
            </Ghost>
            <Ghost
              href={routes.resources}
              onColorType={colorType.GRAY}
              color={colors.WHITE}
              style={{ 'font-size': '13px' }}
              mb={10}
            >
              Productos y servicios
            </Ghost>
            <Ghost
              href={routes.correspondents}
              onColorType={colorType.GRAY}
              color={colors.WHITE}
              style={{ 'font-size': '13px' }}
            >
              Nuestros corresponsales
            </Ghost>
          </Div>
        </Div>

        <Box marginTop="30px">
          <Title size={18} color={colors.WHITE} mb={12}>
            Contacto
          </Title>
          <Div isFlex direction="column" align="start">
            <Ghost
              href={routes.message.contactUs}
              onColorType={colorType.GRAY}
              color={colors.WHITE}
              style={{ 'font-size': '13px' }}
            >
              Centro de ayuda
            </Ghost>
          </Div>
        </Box>

        <Box marginTop="30px">
          <Title size={18} color={colors.WHITE} mb={12}>
            Legal
          </Title>
          <Div isFlex direction="column" align="start">
            <Ghost
              href={routes.termsAndConditions}
              onColorType={colorType.GRAY}
              color={colors.WHITE}
              style={{ 'font-size': '13px' }}
              mb={10}
            >
              Términos de uso
            </Ghost>
            <Ghost
              href={routes.dataProcessingPolicy}
              onColorType={colorType.GRAY}
              color={colors.WHITE}
              style={{ 'font-size': '13px' }}
            >
              Política de tratamiento de datos
            </Ghost>
          </Div>
        </Box>
      </ContainerInfo>

      <Div
        isFlex
        justify="center"
        style={{ height: '10%', padding: '0 10px' }}
      >
        <LogoCASF>
          <ImageLazyLoad
            src={casf}
            alt="Consejo Académico de Supervisión Financiera (CASF)"
            width="100%"
          />
        </LogoCASF>
      </Div>
    </FooterContainer>
    <Div
      style={{ height: '100px', padding: '10px 0' }}
      isFlex
      direction="column"
    >
      <Text
        size={9}
        color={colors.GRAY_9}
        isCenter
        width="70%"
        style={{ height: '50%' }}
      >
        © 2026 Akademia, todos los derechos reservados
      </Text>
    </Div>
  </>
);

const FooterContainer = styled.div`
  width: 100%;
  min-height: 590px;
  background: ${colors.GRAY_9};
  position: relative;
`;

const ContainerInfo = styled.div`
  padding: 35px 50px 20px;
  height: 90%;
  position: relative;
  z-index: 1;
  border-bottom: 1px solid ${colors.WHITE};
`;

const LogoCASF = styled.div`
  width: 220px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
